// import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import bankMasterData from "../../../MasterJson/bank_master.json"

// const ResponsePopup = ({ isOpen, onClose, response, status }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg p-6 max-w-md w-full">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-xl font-bold">
//             {status === "success" ? "Success" : status === "error" ? "Error" : "Response"}
//           </h3>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700"
//           >
//             ✕
//           </button>
//         </div>

//         <div className={`p-4 rounded mb-4 ${
//           status === "success" ? "bg-green-100" : 
//           status === "error" ? "bg-red-100" : "bg-blue-100"
//         }`}>
//           {status === "success" && (
//             <div>
//               <p className="font-semibold mb-2">Beneficiary added successfully!</p>
//               <div className="space-y-2 text-sm">
//                 {response.beneficiary_id && (
//                   <p><span className="font-medium">Beneficiary ID:</span> {response.beneficiary_id}</p>
//                 )}
//                 {response.beneficiary_name && (
//                   <p><span className="font-medium">Name:</span> {response.beneficiary_name}</p>
//                 )}
//                 {response.beneficiary_status && (
//                   <p><span className="font-medium">Status:</span> {response.beneficiary_status}</p>
//                 )}
//                 {Object.entries(response).map(([key, value]) => {
//                   if (!['beneficiary_id', 'beneficiary_name', 'beneficiary_status'].includes(key)) {
//                     return (
//                       <p key={key}>
//                         <span className="font-medium">{key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</span> {value}
//                       </p>
//                     );
//                   }
//                   return null;
//                 })}
//               </div>
//             </div>
//           )}

//           {status === "error" && (
//             <div>
//               <p className="font-semibold mb-2">Error adding beneficiary</p>
//               <p>{typeof response === 'string' ? response : response.message || 'Something went wrong.'}</p>
//             </div>
//           )}

//           {status !== "success" && status !== "error" && (
//             <pre className="whitespace-pre-wrap text-sm">
//               {JSON.stringify(response, null, 2)}
//             </pre>
//           )}
//         </div>

//         <div className="flex justify-end">
//           {status === "success" ? (
//             <button
//               onClick={onClose}
//               className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//             >
//               Continue
//             </button>
//           ) : (
//             <button
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
//             >
//               Close
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const AddNewBeneficiary = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const { remitterInfo = {} } = location.state || {};
//     const token = remitterInfo?.token;
//     const username = useSelector((store) => store.auth.employeeDetails.username);

//     const { callApi: addbeneficiary } = useApi("/ppi/add/beneficiary", "POST");

//     const [formData, setFormData] = useState({
//         remitterName: remitterInfo.name || "",
//         remitterPhoneNumber: remitterInfo.mobileNumber || "",
//         beneficiaryName: "",
//         beneficiaryPhoneNumber: "",
//         bankName: "",
//         bankIfscCode: "",
//         accountNumber: "",
//         confirmAccountNumber: "",
//         paymentMode: "IMPS",
//         mpin: ""
//     });

//     const [formErrors, setFormErrors] = useState({});
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [apiStatus, setApiStatus] = useState({
//         type: null,
//         message: ""
//     });

//     const [showPopup, setShowPopup] = useState(false);
//     const [popupData, setPopupData] = useState({});
//     const [popupStatus, setPopupStatus] = useState(null);

//     const [formSubmitted, setFormSubmitted] = useState(false);

//     const [bankSearch, setBankSearch] = useState("");
//     const [showBankDropdown, setShowBankDropdown] = useState(false);

//     const [showConfirmAccount, setShowConfirmAccount] = useState(false);

//     const bankSearchRef = useRef(null);

//     useEffect(() => {
//         if (remitterInfo.name && remitterInfo.mobileNumber) {
//             setFormData(prev => ({
//                 ...prev,
//                 remitterName: remitterInfo.name,
//                 remitterPhoneNumber: remitterInfo.mobileNumber
//             }));
//         }
//     }, [remitterInfo]);

//     const bankList = useMemo(() => {
//         return bankMasterData.map(bank => ({
//             code: bank.bank_code,
//             name: bank.bank_name,
//             ifscPrefix: bank.ifsc_prefix,
//             ifscSample: bank.ifsc_code_sample
//         }));
//     }, []);

//     const filteredBanks = useMemo(() => {
//         if (!bankSearch) return bankList;

//         const searchTerm = bankSearch.toLowerCase();
//         return bankList.filter(bank => 
//             bank.name.toLowerCase().includes(searchTerm) ||
//             bank.code.toLowerCase().includes(searchTerm)
//         );
//     }, [bankSearch, bankList]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         let sanitizedValue = value;

//         if (name === "beneficiaryName" || name === "remitterName") {
//             sanitizedValue = value.replace(/[^a-zA-Z\s.',-]/g, '').substring(0, 50);
//         } else if (name === "beneficiaryPhoneNumber" || name === "remitterPhoneNumber") {
//             sanitizedValue = value.replace(/\D/g, '').substring(0, 10);
//         } else if (name === "accountNumber" || name === "confirmAccountNumber") {
//             sanitizedValue = value.replace(/\D/g, '').substring(0, 20);
//         } else if (name === "bankIfscCode") {
//             sanitizedValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().substring(0, 11);
//         } else if (name === "mpin") {
//             sanitizedValue = value.replace(/\D/g, '').substring(0, 6);
//         }

//         setFormData(prevData => ({
//             ...prevData,
//             [name]: sanitizedValue
//         }));

//         if (formErrors[name]) {
//             setFormErrors(prev => ({
//                 ...prev,
//                 [name]: ""
//             }));
//         }
//     };

//     const getMaskedAccountNumber = (number) => {
//         if (!number) return '';
//         if (number.length <= 4) return '*'.repeat(number.length);

//         return '*'.repeat(number.length - 4) + number.slice(-4);
//     };

//     const handleBankSelect = (bank) => {
//         setFormData(prev => ({
//             ...prev,
//             bankName: bank.name,
//             bankIfscCode: bank.ifscSample
//         }));
//         setBankSearch("");
//         setShowBankDropdown(false);
//     };

//     const handleBankSearchChange = (e) => {
//         const value = e.target.value;
//         setBankSearch(value);
//         setShowBankDropdown(true);

//         if (value === "") {
//             setFormData(prev => ({
//                 ...prev,
//                 bankName: "",
//                 bankIfscCode: ""
//             }));
//         }
//     };

//     const handleBankSearchFocus = () => {
//         setShowBankDropdown(true);
//         if (formData.bankName && !bankSearch) {
//             setBankSearch(formData.bankName);
//         }
//     };

//     const toggleShowConfirmAccount = () => {
//         setShowConfirmAccount(!showConfirmAccount);
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (bankSearchRef.current && !bankSearchRef.current.contains(event.target)) {
//                 setShowBankDropdown(false);
//                 setBankSearch("");
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     const validateForm = () => {
//         const errors = {};
//         const phoneRegex = /^[6-9]\d{9}$/;
//         const nameRegex = /^[A-Za-z\s.',-]{3,50}$/;
//         const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
//         const accountNumberRegex = /^\d{9,18}$/;
//         const mpinRegex = /^\d{4,6}$/;

//         if (!formData.beneficiaryName.trim()) {
//             errors.beneficiaryName = "Beneficiary name is required";
//         } else if (!nameRegex.test(formData.beneficiaryName)) {
//             errors.beneficiaryName = "Provide a valid name (3-50 characters, letters only)";
//         }

//         if (!formData.beneficiaryPhoneNumber.trim()) {
//             errors.beneficiaryPhoneNumber = "Phone number is required";
//         } else if (!phoneRegex.test(formData.beneficiaryPhoneNumber)) {
//             errors.beneficiaryPhoneNumber = "Must be a valid 10-digit Indian mobile number starting with 6-9";
//         }

//         if (!formData.bankName || formData.bankName === "Select Bank") {
//             errors.bankName = "Please select a bank";
//         }

//         if (!formData.bankIfscCode.trim()) {
//             errors.bankIfscCode = "IFSC code is required";
//         } else if (!ifscRegex.test(formData.bankIfscCode)) {
//             errors.bankIfscCode = "Invalid IFSC code format (e.g., HDFC0001234)";
//         }

//         if (!formData.accountNumber.trim()) {
//             errors.accountNumber = "Account number is required";
//         } else if (!accountNumberRegex.test(formData.accountNumber)) {
//             errors.accountNumber = "Account number must be 9-18 digits";
//         }

//         if (!formData.confirmAccountNumber.trim()) {
//             errors.confirmAccountNumber = "Confirm account number is required";
//         } else if (formData.accountNumber !== formData.confirmAccountNumber) {
//             errors.confirmAccountNumber = "Account numbers do not match";
//         }

//         if (!formData.remitterPhoneNumber.trim()) {
//             errors.remitterPhoneNumber = "Remitter phone number is required";
//         } else if (!phoneRegex.test(formData.remitterPhoneNumber)) {
//             errors.remitterPhoneNumber = "Must be a valid 10-digit Indian mobile number starting with 6-9";
//         }

//         if (!formData.remitterName.trim()) {
//             errors.remitterName = "Remitter name is required";
//         } else if (!nameRegex.test(formData.remitterName)) {
//             errors.remitterName = "Provide a valid name (3-50 characters, letters only)";
//         }

//         if (!formData.mpin.trim()) {
//             errors.mpin = "MPIN is required";
//         } else if (!mpinRegex.test(formData.mpin)) {
//             errors.mpin = "MPIN must be 4-6 digits";
//         }

//         return errors;
//     };

//     const handleCancel = () => {
//         navigate(-1);
//     };

//     const handlePopupClose = () => {
//         setShowPopup(false);

//         if (popupStatus === "success") {
//             navigate("/ppi-remitterpage", {
//                 state: {
//                     remitterDetails: {
//                         name: remitterInfo.name,
//                         mobileNumber: remitterInfo.mobileNumber,
//                         amountLimit: remitterInfo.amountLimit,
//                         isVerified: remitterInfo.isVerified,
//                         token: token
//                     },
//                     refresh: true
//                 }
//             });
//         } else {
//             setFormSubmitted(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formSubmitted || isSubmitting) {
//             return;
//         }

//         const errors = validateForm();
//         setFormErrors(errors);

//         if (Object.keys(errors).length === 0) {
//             setIsSubmitting(true);
//             setFormSubmitted(true);
//             setApiStatus({ type: null, message: "" });

//             try {
//                 const requestBody = {
//                     remitterPhoneNumber: formData.remitterPhoneNumber.trim(),
//                     beneficiaryName: formData.beneficiaryName.trim(),
//                     beneficiaryPhoneNumber: formData.beneficiaryPhoneNumber.trim(),
//                     bankName: formData.bankName,
//                     bankIfscCode: formData.bankIfscCode.trim(),
//                     accountNumber: formData.accountNumber.trim(),
//                     paymentMode: formData.paymentMode,
//                     remitterName: formData.remitterName.trim(),
//                     token: token,
//                     user_name : username,
//                     mpin:formData.mpin
//                 };

//                 const response = await addbeneficiary(requestBody);

//                 if (response && response.beneficiary_id && response.beneficiary_status === "APPROVED") {
//                     setApiStatus({
//                         type: "success",
//                         message: `Beneficiary ${response.beneficiary_name || ''} added successfully!`
//                     });

//                     setPopupData(response);
//                     setPopupStatus("success");
//                     setShowPopup(true);
//                 } else {
//                     throw new Error(response?.message || "Failed to add beneficiary.");
//                 }
//             } catch (error) {
//                 console.error("Error adding beneficiary:", error);

//                 setApiStatus({
//                     type: "error",
//                     message: error.message || "Failed to add beneficiary. Please try again."
//                 });

//                 setPopupData(error.message || "Failed to add beneficiary");
//                 setPopupStatus("error");
//                 setShowPopup(true);
//             } finally {
//                 setIsSubmitting(false);
//             }
//         }
//     };

//     useEffect(() => {
//         const inactivityTimer = setTimeout(() => {
//             setFormData(prevData => ({
//                 ...prevData,
//                 accountNumber: "",
//                 confirmAccountNumber: "",
//                 mpin: ""
//             }));
//             setApiStatus({
//                 type: "info",
//                 message: "Form partially reset due to inactivity"
//             });
//         }, 5 * 60 * 1000);

//         return () => clearTimeout(inactivityTimer);
//     }, [formData]);

//     return (
//         <div className="p-6 max-w-xl mx-auto bg-white rounded-lg shadow-md">
//             <h2 className="text-2xl font-bold mb-4 text-center">Add New Beneficiary</h2>
//             <div className="bg-green-100 text-green-800 text-center p-2 rounded mb-4 text-sm">
//                 "Add a beneficiary and make sure your funds have a happy landing!"
//             </div>

//             {/* {apiStatus.type && (
//                 <div className={`${apiStatus.type === "error" ? "bg-red-100 text-red-800" : 
//                                    apiStatus.type === "success" ? "bg-green-100 text-green-800" : 
//                                    "bg-blue-100 text-blue-800"} p-3 rounded mb-4 text-sm`}>
//                     {apiStatus.message}
//                 </div>
//             )} */}

//             <form className="space-y-4" onSubmit={handleSubmit} noValidate>

//                 <div className="relative" ref={bankSearchRef}>
//                     <input
//                         type="text"
//                         placeholder="Search and select bank"
//                         value={bankSearch || (!showBankDropdown ? formData.bankName : '')}
//                         onChange={handleBankSearchChange}
//                         onFocus={handleBankSearchFocus}
//                         className={`w-full p-2 border rounded ${formErrors.bankName ? 'border-red-500' : ''}`}
//                     />
//                     {formErrors.bankName && <p className="text-red-500 text-xs mt-1">{formErrors.bankName}</p>}

//                     {showBankDropdown && (
//                         <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
//                             {filteredBanks.length > 0 ? (
//                                 filteredBanks.map((bank, index) => (
//                                     <div
//                                         key={index}
//                                         className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
//                                         onClick={() => handleBankSelect(bank)}
//                                     >
//                                         <div className="font-medium">{bank.name}</div>
//                                         <div className="text-xs text-gray-500">Code: {bank.code} | IFSC: {bank.ifscSample}</div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="p-2 text-gray-500 text-sm">No banks found</div>
//                             )}
//                         </div>
//                     )}
//                 </div>

//                 <div>
//                     <input
//                         type="text"
//                         name="beneficiaryName"
//                         value={formData.beneficiaryName}
//                         onChange={handleChange}
//                         placeholder="Account Holder Name"
//                         className={`w-full p-2 border rounded ${formErrors.beneficiaryName ? 'border-red-500' : ''}`}
//                         maxLength={50}
//                         required
//                     />
//                     {formErrors.beneficiaryName && <p className="text-red-500 text-xs mt-1">{formErrors.beneficiaryName}</p>}
//                 </div>

//                 <div>
//                     <input
//                         type="text"
//                         name="accountNumber"
//                         value={formData.accountNumber}
//                         onChange={handleChange}
//                         placeholder="Account Number"
//                         className={`w-full p-2 border rounded ${formErrors.accountNumber ? 'border-red-500' : ''}`}
//                         maxLength={18}
//                         inputMode="numeric"
//                         autoComplete="off"
//                         required
//                     />
//                     {formErrors.accountNumber && <p className="text-red-500 text-xs mt-1">{formErrors.accountNumber}</p>}
//                 </div>

//                 <div className="relative">
//                     <input
//                         type={showConfirmAccount ? "text" : "password"}
//                         name="confirmAccountNumber"
//                         value={formData.confirmAccountNumber}
//                         onChange={handleChange}
//                         placeholder="Confirm Account Number"
//                         className={`w-full p-2 border rounded ${formErrors.confirmAccountNumber ? 'border-red-500' : ''}`}
//                         maxLength={18}
//                         inputMode="numeric"
//                         autoComplete="off"
//                         onPaste={(e) => e.preventDefault()}
//                         onCopy={(e) => e.preventDefault()}
//                         required
//                     />
//                     <button
//                         type="button"
//                         className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
//                         onClick={toggleShowConfirmAccount}
//                     >
//                         {showConfirmAccount ? 
//                             <span className="text-xs">HIDE</span> : 
//                             <span className="text-xs">SHOW</span>
//                         }
//                     </button>
//                     {formErrors.confirmAccountNumber && <p className="text-red-500 text-xs mt-1">{formErrors.confirmAccountNumber}</p>}
//                 </div>

//                 <div>
//                     <input
//                         type="tel"
//                         name="beneficiaryPhoneNumber"
//                         value={formData.beneficiaryPhoneNumber}
//                         onChange={handleChange}
//                         placeholder="Beneficiary Phone Number"
//                         className={`w-full p-2 border rounded ${formErrors.beneficiaryPhoneNumber ? 'border-red-500' : ''}`}
//                         maxLength={10}
//                         inputMode="tel"
//                         required
//                     />
//                     {formErrors.beneficiaryPhoneNumber && <p className="text-red-500 text-xs mt-1">{formErrors.beneficiaryPhoneNumber}</p>}
//                 </div>

//                 <div>
//                     <input
//                         type="text"
//                         name="bankIfscCode"
//                         value={formData.bankIfscCode}
//                         onChange={handleChange}
//                         placeholder="IFSC Code"
//                         className={`w-full p-2 border rounded ${formErrors.bankIfscCode ? 'border-red-500' : ''}`}
//                         maxLength={11}
//                         required
//                     />
//                     {formErrors.bankIfscCode && <p className="text-red-500 text-xs mt-1">{formErrors.bankIfscCode}</p>}
//                 </div>

//                 <div>
//                     <input
//                         type="text"
//                         name="remitterName"
//                         value={formData.remitterName}
//                         onChange={handleChange}
//                         placeholder="Remitter Name"
//                         className={`w-full p-2 border rounded ${formErrors.remitterName ? 'border-red-500' : ''}`}
//                         disabled={remitterInfo.name && remitterInfo.isVerified}
//                         maxLength={50}
//                         required
//                     />
//                     {formErrors.remitterName && <p className="text-red-500 text-xs mt-1">{formErrors.remitterName}</p>}
//                 </div>

//                 <div>
//                     <input
//                         type="tel"
//                         name="remitterPhoneNumber"
//                         value={formData.remitterPhoneNumber}
//                         onChange={handleChange}
//                         placeholder="Remitter Phone Number"
//                         className={`w-full p-2 border rounded ${formErrors.remitterPhoneNumber ? 'border-red-500' : ''}`}
//                         disabled={remitterInfo.mobileNumber && remitterInfo.isVerified}
//                         maxLength={10}
//                         inputMode="tel"
//                         required
//                     />
//                     {formErrors.remitterPhoneNumber && <p className="text-red-500 text-xs mt-1">{formErrors.remitterPhoneNumber}</p>}
//                 </div>

//                 <div>
//                     <select
//                         name="paymentMode"
//                         value={formData.paymentMode}
//                         onChange={handleChange}
//                         className="w-full p-2 border rounded"
//                         required
//                     >
//                         <option value="IMPS">IMPS</option>
//                         <option value="NEFT">NEFT</option>
//                         <option value="RTGS">RTGS</option>
//                     </select>
//                 </div>

//                 <div>
//                     <input
//                         type="password"
//                         name="mpin"
//                         value={formData.mpin}
//                         onChange={handleChange}
//                         placeholder="MPIN"
//                         className={`w-full p-2 border rounded ${formErrors.mpin ? 'border-red-500' : ''}`}
//                         maxLength={6}
//                         autoComplete="new-password"
//                         inputMode="numeric"
//                         required
//                     />
//                     {formErrors.mpin && <p className="text-red-500 text-xs mt-1">{formErrors.mpin}</p>}
//                 </div>

//                 <div className="flex justify-between pt-4">
//                     <button
//                         type="button"
//                         onClick={handleCancel}
//                         className="px-6 py-2 border border-green-600 text-green-600 rounded hover:bg-green-50"
//                         disabled={isSubmitting}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         type="submit"
//                         className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:bg-green-300"
//                         disabled={isSubmitting || formSubmitted}
//                     >
//                         {isSubmitting ? 'Processing...' : 'Verify'}
//                     </button>
//                 </div>
//             </form>

//             <ResponsePopup 
//                 isOpen={showPopup} 
//                 onClose={handlePopupClose} 
//                 response={popupData} 
//                 status={popupStatus} 
//             />
//         </div>
//     );
// };

// export default AddNewBeneficiary;




import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../../ResuableCompoment/Popup";
import useApi from "../../../CustomHooks/useApi";
import BankSelect from "../../../ResuableCompoment/BankSelect";
import { useSelector, useDispatch } from "react-redux";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../Store/Slices/WalletSlice";
import bankList from "../DMT/Addbeneficiary/banklist.json";

const AddNewBeneficiary = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
  const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
  const username = useSelector((store) => store.auth.employeeDetails.username);
  const [bankSearch, setBankSearch] = useState("");
  const [showBankList, setShowBankList] = useState(false);

  const impsType = useSelector(
    (state) => state.auth.remitterData?.type // "IMPS1" | "IMPS2"
  );

  console.log("impassstyeyee", impsType)

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

  const [bank, setBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankcode, setBankcode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [mpin, setMpin] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");

  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [navigateTo, setNavigateTo] = useState(null);
  const [navigateState, setNavigateState] = useState(null);

  const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
    setPopupMessage(message);
    setPopupType(type);
    setNavigateTo(navigateTo);
    setNavigateState(navigateState);
    setShowPopup(true);
  };

  const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

  const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

  // const handleConfirm = async () => {
  //   let newErrors = {};

  //   // if (!bank) newErrors.bank = "Please select a bank.";
  //   if (!selectedBankId) newErrors.bank = "Please select a bank.";

  //   if (!accountHolderName) {
  //     newErrors.accountHolderName = "Account Holder Name is required.";
  //   } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
  //     newErrors.accountHolderName =
  //       "Account Holder Name can contain only alphabets and spaces.";
  //   }

  //   if (!accountNumber) {
  //     newErrors.accountNumber = "Account Number is required.";
  //   } else if (accountNumber.length < 6 || accountNumber.length > 20) {
  //     newErrors.accountNumber = "Account Number must be between 6 and 20 digits.";
  //   }

  //   if (!confirmAccountNumber) {
  //     newErrors.confirmAccountNumber = "Please confirm your Account Number.";
  //   } else if (confirmAccountNumber.length < 6 || confirmAccountNumber.length > 20) {
  //     newErrors.confirmAccountNumber = "Confirm Account Number must be between 6 and 20 digits.";
  //   } else if (accountNumber !== confirmAccountNumber) {
  //     newErrors.confirmAccountNumber = "Account numbers do not match.";
  //   }


  //   if (!ifscCode) newErrors.ifscCode = "IFSC Code is required.";

  //   if (!mobileNumber) newErrors.mobileNumber = "Mobile Number is required.";
  //   else if (!/^\d{10}$/.test(mobileNumber)) newErrors.mobileNumber = "Invalid Mobile Number. It should be 10 digits.";

  //   if (!mpin) {
  //     newErrors.mpin = "MPIN is required.";
  //   } else if (!/^\d{6}$/.test(mpin)) {
  //     newErrors.mpin = "MPIN must be exactly 6 digits.";
  //   }

  //   setErrors(newErrors);

  //   if (Object.keys(newErrors).length > 0) {
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const requestBody = {
  //       remitterPhoneNumber: remitter_mobile_number,
  //       remitterName: remitter_fullname,
  //       beneficiaryName: accountHolderName,
  //       beneficiaryPhoneNumber: mobileNumber,
  //       bankName: bank,
  //       bankIfscCode: ifscCode,
  //       accountNumber: accountNumber,
  //       paymentMode: "IMPS",
  //       bank_code: bankcode,
  //       user_name: username,
  //       mpin: mpin,
  //     };

  //     const requestHeaders = {
  //       Cookie: "JSESSIONID=A839C7E986CC50D62049244503766A47",
  //     };



  //     const data = await addbeni(requestBody, null, requestHeaders);

  //     console.log("dataa", data);

  //     if (data.beneficiary_id) {
  //       showPopupMessage(
  //         `Beneficiary Details : BeneficiaryId : ${data.beneficiary_id}, BeneficiaryStatus: ${data.beneficiary_status}, BeneficiaryName : ${data.beneficiary_name}, BeneficiaryIfscCode : ${data.beneficiary_ifsc_code}`,
  //         "success",
  //         "/remittance");
  //       return;
  //     } else if (data.error_code == "202") {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     } else if (data.error_code === "DMT000") {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     } else {
  //       showPopupMessage(`Error: ${data.message}`, "error");
  //     }
  //   } catch (error) {
  //     showPopupMessage("Something went wrong. Please try again later.", "error");
  //   } finally {
  //     setIsLoading(false);
  //     dispatch(fetchWalletBalance());
  //   }
  // };

  const handleConfirm = async () => {
    const newErrors = {};

    // ---------- COMMON ----------
    if (!accountHolderName) {
      newErrors.accountHolderName = "Account Holder Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
      newErrors.accountHolderName =
        "Account Holder Name can contain only alphabets and spaces.";
    }

    if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
      newErrors.accountNumber =
        "Account Number must be between 6 and 20 digits.";
    }

    // if (confirmAccountNumber !== accountNumber) {
    //   newErrors.confirmAccountNumber = "Account numbers do not match.";
    // }

    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
    }

    if (!mpin || !/^\d{6}$/.test(mpin)) {
      newErrors.mpin = "MPIN must be exactly 6 digits.";
    }

    // ---------- IMPS2 (ORIGINAL) ----------
    if (impsType === "IMPS2") {
      if (!bank) newErrors.bank = "Please select a bank";
      if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
    }

    // ---------- IMPS1 (NEW) ----------
    if (impsType === "IMPS1") {
      if (!selectedBankId) newErrors.bank = "Please select a bank";
      // if (!selectedBankIfsc)
      //   newErrors.ifscCode = "Selected bank does not have a valid IFSC";
      if (impsType === "IMPS1") {
        if (!selectedBankId) {
          newErrors.bank = "Please select a bank";
        }
      }
    }

    // ---------- OTP (IMPS1 STEP 2) ----------
    if (impsType === "IMPS1" && showOtpInput) {
      if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
        newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    try {
      // ================= IMPS2 (ORIGINAL PAYLOAD) =================
      if (impsType === "IMPS2") {
        const imps2Payload = {
          remitterPhoneNumber: remitter_mobile_number,
          remitterName: remitter_fullname,
          beneficiaryName: accountHolderName,
          beneficiaryPhoneNumber: mobileNumber,
          bankName: bank,
          bankIfscCode: ifscCode,
          accountNumber,
          user_name: username,
          mpin,
          bank_code: bankcode,
          type: "IMPS2"
        };

        const res = await addbeni(imps2Payload);

        if (res?.beneficiary_id) {
          setPopupMessage("Beneficiary added successfully.");
          setPopupType("success");
          setNavigateTo("/ppiremitter");
          setShowPopup(true);
          return;
        }

        throw new Error(res?.message || "Failed to add beneficiary");
      }

      // ================= IMPS1 (NEW PAYLOAD) =================
      const imps1Payload = {
        remitterPhoneNumber: remitter_mobile_number,
        remitterName: remitter_fullname,
        beneficiaryName: accountHolderName,
        beneficiaryPhoneNumber: mobileNumber,
        accountNumber,
        bankName: selectedBankName,
        bank_code: selectedBankId,
        bankIfscCode: selectedBankIfsc,
        user_name: username,
        mpin,
        type: "IMPS2"
      };

      // ===== IMPS1 STEP 1: SEND OTP =====
      // if (!showOtpInput) {
      //   const res = await addbeni({
      //     ...imps1Payload,
      //     otp: null,
      //     token: null
      //   });

      //   if (res?.error_code === "DMT001") {
      //     setOtpToken(res?.action_params?.token || "");
      //     setShowOtpInput(true);
      //     return;
      //   }

      //   if (res?.token) {
      //     setOtpToken(res.token);
      //     setShowOtpInput(true);
      //     setPopupMessage("OTP sent. Please enter OTP to continue.");
      //     setPopupType("info");
      //     setShowPopup(true);
      //     return;
      //   }

      //   throw new Error(res?.message || "Failed to send OTP");
      // }

      // ===== IMPS1 STEP 2: VERIFY OTP =====
      const res = await addbeni({
        ...imps1Payload
      });

      if (res?.beneficiary_id) {
        setPopupMessage("Beneficiary added successfully.");
        setPopupType("success");
        setNavigateTo("/ppiremitter");
        setShowPopup(true);
        return;
      }

      throw new Error(res?.message || "OTP verification failed");
    } catch (err) {
      setPopupMessage(err.message || "Something went wrong.");
      setPopupType("error");
      setShowPopup(true);
    } finally {
      setIsLoading(false);

      dispatch(fetchWalletBalance());
      dispatch(fetchAepsBalance());
      dispatch(fetchSettlementBalance());
    }
  };

  const handleCancel = () => {
    navigate("/ppiremitter");
  };

  const handleChange = (fieldName, value) => {
    const sanitizedValue =
      fieldName === "mobileNumber" || fieldName.includes("Account")
        ? value.replace(/\D/g, "")
        : value;

    switch (fieldName) {
      case "accountHolderName":
        setAccountHolderName(sanitizedValue);
        break;
      case "accountNumber":
        setAccountNumber(sanitizedValue);
        break;
      case "confirmAccountNumber":
        setConfirmAccountNumber(sanitizedValue);
        break;
      case "mobileNumber":
        setMobileNumber(sanitizedValue);
        break;
      case "mpin":
        setMpin(sanitizedValue);
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
  };


  // return (
  //   <div className="w-full max-w-[50rem] mx-auto bg-white p-8 rounded-lg shadow-md mt-10">
  //     <h2 className="text-2xl font-semibold text-center mb-4">Add New Beneficiary</h2>

  //     <div className="bg-green-100 text-green-700 text-center text-sm py-2 rounded mb-6">
  //       "Add a beneficiary and make sure your funds have a happy landing!"
  //     </div>

  //     <div className="overflow-y-auto">
  //       <form className="space-y-4">
  //         <div>
  //           <BankSelect
  //             ifscInput={ifscCode}
  //             onIfscChange={(e) => {
  //               setIfscCode(e.target.value.toUpperCase());
  //               setErrors((prevErrors) => ({ ...prevErrors, ifscCode: '' }));
  //             }}
  //             onSelect={(selected) => {
  //               setBank(selected.bank_name);
  //               setBankcode(selected.bank_code);
  //             }}
  //           />
  //           {errors.ifscCode && <p className="text-red-500 text-xs mt-1">{errors.ifscCode}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-name"
  //             value={accountHolderName}
  //             onChange={(e) => handleChange("accountHolderName", e.target.value)}
  //             placeholder="Account Holder Name"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.accountHolderName && <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-account"
  //             value={accountNumber}
  //             onPaste={handlePaste}
  //             maxLength={20}
  //             onChange={(e) => handleChange("accountNumber", e.target.value)}
  //             placeholder="Account Number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.accountNumber && <p className="text-red-500 text-xs mt-1">{errors.accountNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-confirm-account"
  //             value={confirmAccountNumber}
  //             onPaste={handlePaste}
  //             maxLength={20}
  //             onChange={(e) => handleChange("confirmAccountNumber", e.target.value)}
  //             placeholder="Confirm Account Number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.confirmAccountNumber && <p className="text-red-500 text-xs mt-1">{errors.confirmAccountNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="text"
  //             name="disable-autofill-mobile"
  //             value={mobileNumber}
  //             maxLength={10}
  //             onChange={(e) => handleChange("mobileNumber", e.target.value)}
  //             placeholder="Enter mobile number"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.mobileNumber && <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>}
  //         </div>

  //         <div>
  //           <input
  //             type="password"
  //             autoComplete="new-password"
  //             name="disable-autofill-mpin"
  //             value={mpin}
  //             maxLength={6}
  //             onChange={(e) => handleChange("mpin", e.target.value)}
  //             placeholder="Enter MPIN"
  //             className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  //           />
  //           {errors.mpin && <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>}
  //         </div>
  //       </form>

  //       <div className="flex justify-between pt-4">
  //         <button
  //           type="button"
  //           className="w-[45%] py-2 border border-green-600 text-green-600 rounded hover:bg-green-50"
  //           onClick={handleCancel}
  //         >
  //           Cancel
  //         </button>
  //         <button
  //           type="submit"
  //           onClick={handleConfirm}
  //           disabled={isLoading}
  //           className={`w-[45%] py-2 rounded text-white transition duration-200
  //   ${isLoading
  //               ? 'bg-gray-400 cursor-not-allowed'
  //               : 'bg-green-600 hover:bg-green-700 cursor-pointer'}
  // `}
  //         >
  //           {isLoading ? "Verifying..." : "Verify"}
  //         </button>
  //       </div>
  //       {showPopup && (
  //         <Popup
  //           message={popupMessage}
  //           type={popupType}
  //           onClose={() => {
  //             setShowPopup(false);
  //             setNavigateTo(null);
  //             setNavigateState(null);
  //           }}
  //           navigateTo={navigateTo}
  //           navigateState={navigateState}
  //           showchildren={false}
  //         />
  //       )}
  //     </div>
  //   </div>
  // );

  return (
    <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

      {/* ===== LEFT INFO PANEL ===== */}
      <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
        <h2 className="text-xl font-semibold mb-3">
          Add Beneficiary
        </h2>

        <p className="text-sm text-indigo-100 mb-6">
          Enter beneficiary bank details carefully.
          Transfers can only be made after successful verification.
        </p>

        <ul className="space-y-3 text-sm">
          <li className="flex gap-2">
            <span>✔</span>
            <span>Account number must be correct</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>IFSC determines the bank</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>MPIN is required for security</span>
          </li>
        </ul>
      </div>

      {/* ===== RIGHT FORM PANEL ===== */}
      <div className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

        {/* SECTION: BANK DETAILS */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            Bank Details
          </h3>

          <div className="space-y-4">
            {/* <BankSelect
              ifscInput={ifscCode}
              onIfscChange={(e) => {
                setIfscCode(e.target.value.toUpperCase());
                setErrors((prev) => ({ ...prev, ifscCode: "" }));
              }}
              onSelect={(selected) => {
                setBank(selected.bank_name);
                setBankcode(selected.bank_code);
                setErrors((prev) => ({ ...prev, bank: "" }));
              }}
            />
            {errors.bank && (
              <p className="text-red-500 text-xs mt-1">
                {errors.bank}
              </p>
            )} */}
            {impsType === "IMPS2" && (
              <>
                <BankSelect
                  ifscInput={ifscCode}
                  onIfscChange={(e) => {
                    setIfscCode(e.target.value.toUpperCase());
                    setErrors((prev) => ({ ...prev, ifscCode: "" }));
                  }}
                  onSelect={(selected) => {
                    setBank(selected.bank_name);
                    setBankcode(selected.bank_code);
                    setErrors((prev) => ({ ...prev, bank: "" }));
                  }}
                />

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.bank}
                  </p>
                )}
              </>
            )}
            {/* <select
              value={selectedBankId}
              onChange={(e) => {
  const value = e.target.value;

  if (!value) {
    setSelectedBankId("");
    setSelectedBankName("");
    setSelectedBankIfsc("");
    return;
  }

  const bank = bankList.data.find((b) => b.bank_id === value);
  if (bank) {
    setSelectedBankId(bank.bank_id);
    setSelectedBankName(bank.bank_name);
    setSelectedBankIfsc(bank.bank_ifsc); // ✅ IMPORTANT
    setErrors((prev) => ({ ...prev, bank: "" }));
  }
}}
            >
              <option value="">Select Bank</option>
              {bankList.data.map((bank) => (
                <option key={bank.bank_id} value={bank.bank_id}>
                  {bank.bank_name}
                </option>
              ))}
            </select> */}

            {/* {impsType === "IMPS1" && (
              <>
                <select
                  value={selectedBankId}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (!value) {
                      setSelectedBankId("");
                      setSelectedBankName("");
                      setSelectedBankIfsc("");
                      return;
                    }

                    const bank = bankList.data.find(
                      (b) => b.bank_id === value
                    );

                    if (bank) {
                      setSelectedBankId(bank.bank_id);
                      setSelectedBankName(bank.bank_name);
                      setSelectedBankIfsc(bank.bank_ifsc);
                      setErrors((prev) => ({ ...prev, bank: "" }));
                    }
                  }}
                  className="w-full border rounded-lg px-4 py-2"
                >
                  <option value="">Select Bank</option>
                  {bankList.data.map((bank) => (
                    <option key={bank.bank_id} value={bank.bank_id}>
                      {bank.bank_name}
                    </option>
                  ))}
                </select>

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.bank}
                  </p>
                )}
              </>
            )} */}

            {impsType === "IMPS1" && (
              <div className="relative">
                {/* SEARCH INPUT */}
                <input
                  type="text"
                  value={bankSearch}
                  placeholder="Search bank name"
                  onFocus={() => setShowBankList(true)}
                  // onChange={(e) => {
                  //   setBankSearch(e.target.value);
                  //   setShowBankList(true);
                  //   setErrors((prev) => ({ ...prev, bank: "" }));
                  // }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBankSearch(value);
                    setShowBankList(true);
                  }}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
                />

                {/* DROPDOWN LIST */}
                {showBankList && (
                  <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
                      bg-white border rounded-lg shadow-lg">
                    {bankList.data
                      .filter((bank) =>
                        bank.bank_name
                          .toLowerCase()
                          .includes(bankSearch.toLowerCase())
                      )
                      .map((bank) => (
                        <div
                          key={bank.bank_id}
                          onClick={() => {
                            setSelectedBankId(bank.bank_id);
                            setSelectedBankName(bank.bank_name);
                            setSelectedBankIfsc(bank.bank_ifsc);

                            setBankSearch(bank.bank_name);
                            setShowBankList(false);
                            setErrors((prev) => ({ ...prev, bank: "", ifscCode: "" }));
                          }}
                          className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
                        >
                          {bank.bank_name}
                        </div>
                      ))}

                    {bankList.data.filter((bank) =>
                      bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
                    ).length === 0 && (
                        <div className="px-4 py-2 text-sm text-slate-500">
                          No bank found
                        </div>
                      )}
                  </div>
                )}

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
                )}
              </div>
            )}

            {errors.bank && (
              <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
            )}
            {errors.ifscCode && (
              <p className="text-red-500 text-xs">{errors.ifscCode}</p>
            )}
          </div>
        </div>

        {/* SECTION: ACCOUNT DETAILS */}
        <div className="mb-6">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Account Holder Name */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Holder Name
              </label>
              <input
                type="text"
                value={accountHolderName}
                onChange={(e) => handleChange("accountHolderName", e.target.value)}
                placeholder="Account Holder Name"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.accountHolderName && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.accountHolderName}
                </p>
              )}
            </div>

            {/* Mobile Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Beneficiary Mobile Number
              </label>
              <input
                type="text"
                value={mobileNumber}
                maxLength={10}
                onChange={(e) => handleChange("mobileNumber", e.target.value)}
                placeholder="Beneficiary Mobile Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.mobileNumber && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.mobileNumber}
                </p>
              )}
            </div>

          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

            {/* Account Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Number
              </label>
              <input
                type="text"
                value={accountNumber}
                maxLength={20}
                onChange={(e) => handleChange("accountNumber", e.target.value)}
                placeholder="Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            {/* Confirm Account Number */}
            {/* <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Confirm Account Number
              </label>
              <input
                type="text"
                value={confirmAccountNumber}
                maxLength={20}
                onChange={(e) => handleChange("confirmAccountNumber", e.target.value)}
                placeholder="Confirm Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div> */}

          </div>

          {(errors.accountNumber || errors.confirmAccountNumber) && (
            <p className="text-red-500 text-xs mt-2">
              {errors.accountNumber || errors.confirmAccountNumber}
            </p>
          )}
        </div>


        {/* SECTION: SECURITY */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            MPIN
          </h3>

          <input
            type="password"
            value={mpin}
            maxLength={6}
            onChange={(e) => handleChange("mpin", e.target.value)}
            placeholder="Enter 6-digit MPIN"
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
          {errors.mpin && (
            <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
          )}
        </div>

        {/* {impsType === "IMPS1" && showOtpInput && (
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">
              OTP Verification
            </h3>

            <input
              type="text"
              value={otp}
              maxLength={6}  // keep 6 (covers both)
              // onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              onChange={(e) => {
                setOtp(e.target.value.replace(/\D/g, ""));
                setErrors((prev) => ({ ...prev, otp: "" }));
              }}
              placeholder="Enter 4 or 6 digit OTP"
              className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
            />

            {errors.otp && (
              <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
            )}
          </div>
        )} */}


        {/* ACTION BUTTONS */}
        <div className="flex justify-end gap-4 pt-4 border-t">
          <button
            type="button"
            onClick={handleCancel}
            className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className={`px-6 py-2 rounded-lg text-white font-semibold
            ${isLoading
                ? "bg-slate-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"}`}
          >
            {isLoading ? "Processing..." : "Add Beneficiary"}
          </button>
        </div>
      </div>

      {/* POPUP */}
      {showPopup && (
        <Popup
          message={popupMessage}
          type={popupType}
          onClose={() => {
            setShowPopup(false);
            setNavigateTo(null);
            setNavigateState(null);
          }}
          navigateTo={navigateTo}
          navigateState={navigateState}
          showchildren={false}
        />
      )}
    </div>
  );


};

export default AddNewBeneficiary;